module.exports = __webpack_public_path__ + "img/588x310-01.a89d0c5d.png";